import { User } from './../../api/models/user.model';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export function selectUserId(user: User): number {
    return user.Id;
}

// export interface AccountState extends EntityState<ToroAccountSimple>

export const authAdapter: EntityAdapter<User> = createEntityAdapter<User>({
    selectId: selectUserId
});

export interface AuthState extends EntityState<User> {
    isUserLoggedIn: boolean;
    user: User;
    rememberMe: boolean;
    redirectUrl: string;
    error: any;
    // errorMessageText: string;
    // showResendLink: boolean;
}
